module.exports = __webpack_public_path__ + "img/unsplash_2d4lAQAlbDA_circle.e3bdac06.png";